$(document).ready(function() {
    var currentURL = window.location.href;
    if(currentURL.indexOf('custom-product-') != -1){
      window.location.href = "/";
    }
});
ready('.mw-apo-container .mw-option__control, .metre-container', function(element) {
  //console.log("mw-option__control found...");
	//$(".mw-apo-container").show();
  var tmplateName = $("#template_name_p").val();
  	/**** Creating width and drop array from select box start ****/
      var widthArr = [];
      var dropArr = [];
  	  var optionVal = '';
      $('.mw-apo-container .mw-option__control .mw-option__value').each(function(){
          var mwOptionThis = $(this);
          var mwOptionVal = mwOptionThis.text();
          if(mwOptionVal.indexOf("Please Select") == -1){
              var matrixVals = mwOptionVal.split(' ')[1].split('x');
              widthArr.push(matrixVals[0]);
              dropArr.push(matrixVals[1]);
          }
      });
      let widthUniqueArr = widthArr.filter((widthItem, width_i, width_ar) => width_ar.indexOf(widthItem) === width_i);
      let dropUniqueArr = dropArr.filter((dropItem, drop_i, drop_ar) => drop_ar.indexOf(dropItem) === drop_i);
  	/**** Creating width and drop array from select box End ****/
  	var widthClosest = '';
  	var dropclosest = '';    

  	function changeSelectBoxSelectedValue(widthClosest,dropclosest)
    {
      optionVal = widthClosest+"x"+dropclosest;
      var optionValue = $(".mw-apo-container .mw-option__control option:contains("+optionVal+")").attr('value');
      
	  var id_mw_option = $(".mw-option__control--type-select").attr('id');
      var iddd ="#"+id_mw_option;
      var main_select = document.querySelector(iddd);      
      main_select.value = optionValue;
      main_select.dispatchEvent(new Event('change'))
    }
  
  	function getNextGretrBlindDrop(blindarrToCheck,blindnumberToCheck,blindclosestwidth)
    {      
      var nxtblindGrtrVal = '';  
      for(let arrIndx = 0; arrIndx < blindarrToCheck.length; arrIndx++){
        if(parseInt(blindarrToCheck[arrIndx]) > parseInt(blindnumberToCheck))
        {                
          nxtblindGrtrVal = blindarrToCheck[arrIndx];
          var nextblindoptionVal = blindclosestwidth+"x"+nxtblindGrtrVal;
          var nextblindOptionLength = $(".mw-apo-container .mw-option__control option:contains("+nextblindoptionVal+")").length;
          if(nextblindOptionLength > 0)
          {
            return nxtblindGrtrVal;
          }
        }
      }
    }
  
  	function findclosestNumber()
    {  
      var updatedVariantId = '';
      updatedVariantId = $('.product__info-wrapper .form .product__info-container input[name="id"]').val();
      var selectedVariantPrice = $("#VariantSelectboxHtml .variantoptions .VariantOptionValue[value='"+updatedVariantId+"']").data('variantoptionprice');	
      console.log(selectedVariantPrice);
      var Widthvalue = $("#width").val();
      var DropValue = $("#drop").val();
      if((Widthvalue != '') && (DropValue != ''))
      {
        $("#wdr #ws").text("");
        $("#wdr #ds").text("");
        var curr_width = Math.max.apply(Math, widthUniqueArr);
        for (var i = 0; i < widthUniqueArr.length; i++) {
          if (parseInt(widthUniqueArr[i]) >= parseInt(Widthvalue) && parseInt(curr_width) > parseInt(widthUniqueArr[i])) {
            curr_width = widthUniqueArr[i]
          }
        }          
        var widthClosest = curr_width;

        var curr_drop = Math.max.apply(Math, dropUniqueArr);
        for (var i = 0; i < dropUniqueArr.length; i++) {
          if (parseInt(dropUniqueArr[i]) >= parseInt(DropValue) && parseInt(curr_drop) > parseInt(dropUniqueArr[i])) {
            curr_drop = dropUniqueArr[i]
          }
        }          
        var  dropclosest = curr_drop; 

        var largestDropInArr = Math.max.apply(null,dropUniqueArr);
        var largestLengthInArr = Math.max.apply(null,widthUniqueArr);
        
        if((parseInt(DropValue) <= parseInt(largestDropInArr)) && (parseInt(Widthvalue) <= parseInt(largestLengthInArr)))
        {
          optionVal = widthClosest+"x"+dropclosest;
          var currntOptionLength = $(".mw-apo-container .mw-option__control option:contains("+optionVal+")").length;
          var currntOptionText = '';
          if(currntOptionLength > 0 )
          {
              currntOptionText = $(".mw-apo-container .mw-option__control option:contains("+optionVal+")").text().split(' ')[2];
            //changeSelectBoxSelectedValue(widthClosest,dropclosest);
          }
          else
          {
            var dropclosest = getNextGretrBlindDrop(dropUniqueArr,dropclosest,widthClosest);
            var next_optionVal = widthClosest+"x"+dropclosest;
            currntOptionText = $(".mw-apo-container .mw-option__control option:contains("+next_optionVal+")").text().split(' ')[2];            
          }
          var CurrentOptionPrice = currntOptionText.replace(/[^0-9\.-]+/g,"");
          //var slctdVarntPrice = selectedVariantTextValue.trim().split('-')[1].trim().match(/\d+(?:\.\d+)?/g)[0];
          var slctdVarntPrice = selectedVariantPrice.replace(/[^0-9\.-]+/g,"");
          
          changeSelectBoxSelectedValue(widthClosest,dropclosest);  
          var calculatedPrice = (parseFloat(CurrentOptionPrice) + parseFloat(slctdVarntPrice));
          var calculatedPricewithSymbol = "£"+calculatedPrice.toFixed(2);
          $("#displayUpdatedPrice").text('');
          $("#displayUpdatedPrice").text(calculatedPricewithSymbol);

          $("#calculatedPercentPrice").val('');
          $("#calculatedPercentPrice").val(calculatedPricewithSymbol);
        }
        else
        {
          if(parseInt(DropValue) >= parseInt(largestDropInArr)) 
            {   
                $("#wdr #ds").text(""); 
                $("#wdr #ds").text("Drop exceeded maximum available for this product. Please enter a smaller drop.");
                if(parseInt(Widthvalue) <= parseInt(largestLengthInArr))
                {
                    $("#wdr #ws").text("");
                }
                else
                {
                    $("#wdr #ws").text(""); 
                    $("#wdr #ws").text("Width exceeded maximum available for this product. Please enter a smaller width.");
                }
            }
            if(parseInt(Widthvalue) >= parseInt(largestLengthInArr))
            {
                $("#wdr #ws").text(""); 
                $("#wdr #ws").text("Width exceeded maximum available for this product. Please enter a smaller width.");
                if(parseInt(DropValue) <= parseInt(largestDropInArr))
                {
                    $("#wdr #ds").text("");
                }
                else
                {
                    $("#wdr #ds").text(""); 
                    $("#wdr #ds").text("Drop exceeded maximum available for this product. Please enter a smaller drop.");
                }
            }
            
            $("#displayUpdatedPrice").text('');
            $("#calculatedPercentPrice").val('');
            var id_mw_option_control = $(".mw-option__control--type-select").attr('id');
            var id_optionControl ="#"+id_mw_option_control;
            var main_select_control = document.querySelector(id_optionControl);  
            $(id_optionControl).prop('selectedIndex',0);
            main_select_control.value = '';
            main_select_control.dispatchEvent(new Event('change'))
        }
      } 
      else
      {
        if(Widthvalue == '')
        {
          $("#wdr #ws").text(""); 
          $("#wdr #ws").text("Please enter your Width");
          if(DropValue != '')
          {
            $("#wdr #ds").text("");
          }
          else
          {
            $("#wdr #ds").text(""); 
            $("#wdr #ds").text("Please enter your Drop");
          }
        }
        else if(DropValue == '')
        {
          $("#wdr #ds").text(""); 
          $("#wdr #ds").text("Please enter your Drop");
          if(Widthvalue != '')
          {
            $("#wdr #ws").text("");
          }
          else
          {
            $("#wdr #ws").text(""); 
            $("#wdr #ws").text("Please enter your Width");
          }
        }
      }
    }
  
  	function getNextGreaterValue(arrToCheck,numberToCheck,closestwidth)
    {
      var largestNumberInArr = Math.max(arrToCheck);
      var nxtGrtrVal = '';  
      for(let arrIndx = 0; arrIndx < arrToCheck.length; arrIndx++){
        if(arrToCheck[arrIndx] > numberToCheck)
        {                
          nxtGrtrVal = arrToCheck[arrIndx];
          var nextoptionVal = closestwidth+"x"+nxtGrtrVal;
          var nextOptionLength = $(".mw-apo-container .mw-option__control option:contains("+nextoptionVal+")").length;
          if(nextOptionLength > 0)
          {
        	return nxtGrtrVal;
          }
        }
      }
    }
  
  	function calculatePercentagePrice()
    {
      var updatedVariantId = '';
      updatedVariantId = $('product-form.product-form input[name="id"]').val();
      var selectedVariantPercentage = $("#VariantSelectboxHtml .variantoptions .VariantOptionValue[value='"+updatedVariantId+"']").data('variantmetafieldpercentage');
      var selectedVariantTextValue = $("#VariantSelectboxHtml .variantoptions .VariantOptionValue[value='"+updatedVariantId+"']").text();	

      var percentageDiscount = $("input.percentage_discount").val();
      
      var MetreValue = $("#metres").val();
      var Widthvalue = $("#width").val();
      var DropValue = $("#drop").val();
    
      if((MetreValue != "") && (Widthvalue == '' && DropValue == '')) {
        var metrePrice = parseFloat($(".metre_cost").val());
        $("#wdr #meter-error").text(""); 
        $("#wdr #ws").text("");
        $("#wdr #ds").text("");

        var metrePriceCalculation = parseInt(MetreValue) * metrePrice;

        if($.isNumeric(metrePriceCalculation)){
          var calculatedPricewithSymbol = "£"+metrePriceCalculation.toFixed(2);
          $("#displayRegularPrice").text('');
          $("#displayUpdatedPrice").text('');
          $("#displayUpdatedPrice").text(calculatedPricewithSymbol);
  
          $("#calculatedPercentPrice").val('');
          $("#calculatedPercentPrice").val(calculatedPricewithSymbol);
        } else {
          $("#displayRegularPrice").text('');
          $("#displayUpdatedPrice").text('');
          $("#calculatedPercentPrice").val('');
        }

      } else {
        if(MetreValue == '' && (Widthvalue == '' && DropValue == ''))
        {
          $("#displayRegularPrice").text('');
          $("#displayUpdatedPrice").text('');
          $("#calculatedPercentPrice").val('');
          $("#wdr #meter-error").text(""); 
          $("#wdr #meter-error").text("Please enter the metres amount");
        }
      }

      if((Widthvalue != '' && DropValue != '') && MetreValue == '')
      {
        $("#wdr #meter-error").text(""); 
        $("#wdr #ws").text("");
        $("#wdr #ds").text("");         
        
        var currWidth = Math.max.apply(Math, widthUniqueArr);
        for (var i = 0; i < widthUniqueArr.length; i++) {
          if (parseInt(widthUniqueArr[i]) >= parseInt(Widthvalue) && parseInt(currWidth) > parseInt(widthUniqueArr[i])) {
            currWidth = widthUniqueArr[i]
          }
        }       
        var closestwidth = currWidth;

        var currDrop = Math.max.apply(Math, dropUniqueArr);
        for (var i = 0; i < dropUniqueArr.length; i++) {
          if (parseInt(dropUniqueArr[i]) >= parseInt(DropValue) && parseInt(currDrop) > parseInt(dropUniqueArr[i])) {
            currDrop = dropUniqueArr[i]
          }
        }   
        var ClosestDrop = currDrop;   

        var largestDropInArr = Math.max.apply(null,dropUniqueArr);
        var largestLengthInArr = Math.max.apply(null,widthUniqueArr);
        
        
        if((parseInt(DropValue) <= parseInt(largestDropInArr)) && (parseInt(Widthvalue) <= parseInt(largestLengthInArr)))
        {
          var CurrntoptionVal = closestwidth+"x"+ClosestDrop;         
          var currntOptionLength = $(".mw-apo-container .mw-option__control option:contains("+CurrntoptionVal+")").length;
          var currntOptionText = '';
          if(currntOptionLength > 0 )
          {
            currntOptionText = $(".mw-apo-container .mw-option__control option:contains("+CurrntoptionVal+")").text().split(' ')[2];
          }
          else
          {
            var ClosestDrop = getNextGreaterValue(dropUniqueArr,ClosestDrop,closestwidth)
            var next_optionVal = closestwidth+"x"+ClosestDrop;
            currntOptionText = $(".mw-apo-container .mw-option__control option:contains("+next_optionVal+")").text().split(' ')[2];
          }
          var CurrentOptionPrice = currntOptionText.replace(/[^0-9\.-]+/g,"");
          var slctdVarntPrice = selectedVariantTextValue.trim().split('-')[1].trim().replace(/[^0-9\.-]+/g,"");
          if(selectedVariantPercentage != '')
          {
              var calculatedPrice = (parseFloat(CurrentOptionPrice) + (parseFloat(CurrentOptionPrice)*parseFloat(selectedVariantPercentage)/100) + parseFloat(slctdVarntPrice));
          }
          else
          {
              var calculatedPrice = (parseFloat(CurrentOptionPrice) + parseFloat(slctdVarntPrice));
          }
          changeSelectBoxSelectedValue(closestwidth,ClosestDrop);
          var calculatedPricewithSymbol = "£"+calculatedPrice.toFixed(2);
          $("#displayRegularPrice").text('');
          $("#displayUpdatedPrice").text('');
          $("#displayUpdatedPrice").text(calculatedPricewithSymbol);

          $("#calculatedPercentPrice").val('');
          $("#calculatedPercentPrice").val(calculatedPricewithSymbol);
        }
        else
        {
          console.log(largestDropInArr);
         	if(parseInt(DropValue) >= parseInt(largestDropInArr)) 
            {   
                $("#wdr #ds").text(""); 
                $("#wdr #ds").text("Curtain Drop exceeded maximum available for this product. Please enter a smaller curtain drop.");
                if(parseInt(Widthvalue) <= parseInt(largestLengthInArr))
                {
                  $("#wdr #ws").text("");
                }
                else
                {
                  $("#wdr #ws").text(""); 
                  $("#wdr #ws").text("Track/Pole exceeded maximum available for this product. Please enter a smaller track/pole length.");
                }
            }
            if(parseInt(Widthvalue) >= parseInt(largestLengthInArr))
            {
				      $("#wdr #ws").text(""); 
          		$("#wdr #ws").text("Track/Pole exceeded maximum available for this product. Please enter a smaller track/pole length.");
            	if(parseInt(DropValue) <= parseInt(largestDropInArr))
                {
                  $("#wdr #ds").text("");
                }
                else
                {
                  $("#wdr #ds").text(""); 
                  $("#wdr #ds").text("Curtain Drop exceeded maximum available for this product. Please enter a smaller curtain drop.");
                }
            }
            
            $("#displayRegularPrice").text('');
            $("#displayUpdatedPrice").text('');
            $("#calculatedPercentPrice").val('');
            var id_mw_option_control = $(".mw-option__control--type-select").attr('id');
            var id_optionControl ="#"+id_mw_option_control;
            var main_select_control = document.querySelector(id_optionControl);  
            $(id_optionControl).prop('selectedIndex',0);
            main_select_control.value = '';
            main_select_control.dispatchEvent(new Event('change'))
        }
      }
      else
      {
        if(Widthvalue == '' && MetreValue == '')
        {
          $("#displayUpdatedPrice").text('');
          $("#calculatedPercentPrice").val('');
          $("#wdr #ws").text(""); 
          $("#wdr #ws").text("Please enter your Track/Pole Length");
          if(DropValue != '')
          {
            $("#wdr #ds").text("");
          }
          else
          {
            $("#wdr #ds").text(""); 
            $("#wdr #ds").text("Please enter your Drop");
          }
        }
        else if(DropValue == '' && MetreValue == '')
        {
          $("#displayUpdatedPrice").text('');
          $("#calculatedPercentPrice").val('');
          $("#wdr #ds").text(""); 
          $("#wdr #ds").text("Please enter your Drop");
          if(Widthvalue != '')
          {
            $("#wdr #ws").text("");
          }
          else
          {
            $("#wdr #ws").text(""); 
            $("#wdr #ws").text("Please enter your Track/Pole Length");
          }
        }
      }
    }

    $(document).on('keyup change',"#metres", function (){
      if(tmplateName == 'fabric')
      {
        console.log("agdjngdj")
        calculatePercentagePrice();
      }
      else
      {
          findclosestNumber();
      }
    });
  
  	$(document).on('keyup change',"#width", function (){
        if(tmplateName == 'curtain')
        {
      		calculatePercentagePrice();
        }
        else
        {
          	findclosestNumber();
        }
    });
  
  	$(document).on('keyup change',"#drop", function (){
      	if(tmplateName == 'curtain')
        {
          	calculatePercentagePrice();
        }
      	else
        {
          findclosestNumber();   
        }
    });
  
    var WidthvalueOnLoad = $("#width").val();
    var DropValueOnLoad = $("#drop").val();
    if((WidthvalueOnLoad != '') && (DropValueOnLoad != ''))
    {
      if(tmplateName == 'curtain')
      {
          calculatePercentagePrice();
      }
      else
      {
        findclosestNumber();   
      }
    }
  
    $(document).on('change input', 'product-form.product-form input[name="id"]', function(element) {
      if(tmplateName == 'curtain' || tmplateName == 'fabric')
      {
        calculatePercentagePrice();
      }
    });
    $(document).on('change','.select select.selectOption',function(){
		if(tmplateName == 'curtain')
        {
          calculatePercentagePrice();
        }
        else
        {
          findclosestNumber();   
        }
  	});
    $(document).on('click','#calculatethePrice',function(){
        if(tmplateName == 'curtain' || tmplateName == 'fabric')
        {
          calculatePercentagePrice();
        }
        else
        {
          findclosestNumber();   
        }
    });
    
    //Add product to cart for Metre amount
    function addCustomProductToCartForMetre(productVariantId,Qty,metres){
    
      let formData = {
       'items': [{
        'id': productVariantId,
        'quantity': Qty,
        'properties': {
          'Metres': metres
        }
        }]
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        window.location.href='/cart';
        return response.json();
      })
      .catch((error) => {
        console.log('Error:', error);
      });
    }

    function createCustomProductForMetre(calculatedVariantPrice,ProductTitle,metres)
    {
      var prdctImgSrc = "https:"+$(".banner-slider .slider .product .slider-mobile-gutter .product__media-list .product__media-item .product__modal-opener .product__media img").attr('src');
      $.ajax({
        url: "https://greatbi.esp-digital.com/shopify-greatbritishinterior/frontPanel/index.php?isAjax=Y",
        method: "POST",
        cache: false,
        data:{'ac':'Y3JlYXRlQ3VzdG9tUHJvZHVjdA==','calculatedVariantPrice':calculatedVariantPrice,'ProductTitle':ProductTitle,'metres':metres,'prdctImgSrc':prdctImgSrc}, //createCustomProduct
        success: function(html){
          var obj = jQuery.parseJSON(html);
          if( obj.status == "success" )
          {
            var productVariantId = obj.productVariantId;
            addCustomProductToCartForMetre(productVariantId,1,metres)
          }
          else if(obj.status == "Error")
          {
            var errMsg = obj.Message;
          }
        }
      });
    }


    //Add product to Cart of Track/pole Length and curtain drop
  	function addCustomProductToCart(productVariantId,Qty,matrixSelectedwidthDrop)
    {
      var eyeletColorVal = "";
      if($('.eyelet_colour_drop:visible').length >= 1)
      {
          eyeletColorVal = $('.eyelet_colour_drop #eyelet-colour').val();
      }
      var typeval = "";
      if($(".type_drop input[type='radio'].radioBtnClass").is(':checked')) {
          var typeval = $(".type_drop input[type='radio'].radioBtnClass:checked").val();
          //alert(card_type);
      }
      var styleval = "";
      if($(".style_image_option input[type='radio']").is(':checked')) {
          var styleval = $(".style_image_option input[type='radio']:checked").val();
          //alert(card_type);
      }
      let formData = {
       'items': [{
        'id': productVariantId,
        'quantity': Qty,
         	'properties': {
            'Matrix Value': matrixSelectedwidthDrop,
            'Eyelet Colour':  eyeletColorVal,
            'Type':  typeval,
            'Style':  styleval
          }
        }]
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        window.location.href='/cart';
        return response.json();
      })
      .catch((error) => {
        console.log('Error:', error);
      });
    }
  
  	function createCustomProduct(calculatedVariantPrice,ProductTitle,width,drop,optionspair,Qty,matrixSelectedText)
    {
      var prdctImgSrc = "https:"+$(".banner-slider .slider .product .grid__item .slider-mobile-gutter .product__media-list .product__media-item .product__modal-opener .product__media img").attr('src');
      $.ajax({
        url: "https://greatbi.esp-digital.com/shopify-greatbritishinterior/frontPanel/index.php?isAjax=Y",
        method: "POST",
        cache: false,
        data:{'ac':'Y3JlYXRlQ3VzdG9tUHJvZHVjdA==','calculatedVariantPrice':calculatedVariantPrice,'ProductTitle':ProductTitle,'width':width,'drop':drop,'optionspair':optionspair,'matrixSelectedText':matrixSelectedText,'prdctImgSrc':prdctImgSrc}, //createCustomProduct
        success: function(html){
          var obj = jQuery.parseJSON(html);
          if( obj.status == "success" )
          {
            var prdctId = obj.productId;
            var productVariantId = obj.productVariantId;
            addCustomProductToCart(productVariantId,Qty,matrixSelectedText);
          }
          else if(obj.status == "Error")
          {
            var errMsg = obj.Message;
          }
        }
      });
    }
  
  	$("#addCurtainPrdctToCartBtn").unbind().click(function(){
  	//$(document).on("click","#addCurtainPrdctToCartBtn",function(){
        var MetreValue = $("#metres").val();
        var Widthvalue = $("#width").val();
      	var DropValue = $("#drop").val();
      	var calculatedPercentPriceVal = $("#calculatedPercentPrice").val();
        var matrixSelectedwidthDrop = $(".mw-option__container .mw-option__value .mw-stack--vertical .mw-stack__item .mw-stack--alignment-center .mw-stack__item--fill .mw-option__control option:selected" ).text().trim().split(" ")[0];
      	//console.log("matrixSelectedwidthDrop: ", matrixSelectedwidthDrop);

        if((MetreValue != '') && (Widthvalue == '' && DropValue == '') && (calculatedPercentPriceVal != '')){
          var productVariantId = $('input.product-id').val();
          var prdctTitle = $('.product__info-container .product__title').text().trim()+" - Metres: "+MetreValue+"";

          //console.log(prdctTitle);
          createCustomProductForMetre(calculatedPercentPriceVal,prdctTitle,MetreValue);
          //addCustomProductToCartForMetre(productVariantId,1,MetreValue)
        } else {
          if(MetreValue == '' && (Widthvalue == '' && DropValue == ''))
          {
            $("#wdr #meter-error").text(""); 
            $("#wdr #meter-error").text("Please enter the metres amount");
          }
          $('html').animate({
            scrollTop: $(".breadcrumbs").offset().top
          }, 1000);
        }


        if((Widthvalue != '') && (DropValue != '') && (MetreValue == '') && (calculatedPercentPriceVal != '') && (matrixSelectedwidthDrop != ''))
        {
          var Qty = $('input[name="quantity"]').val();
          var prdctTitle = $('.product__info-container .product__title').text().trim();
          var atcUpdatedVariantId = '';
          atcUpdatedVariantId = $('#app_price_add input[name="id"]').val();
          var selectedVariantNameStr = '#'+$("#VariantSelectboxHtml .variantoptions .VariantOptionValue[value='"+atcUpdatedVariantId+"']").text().trim().split('-')[0].trim().replace(/\s+/g, '').replaceAll("/", "# #")+'#';
          createCustomProduct(calculatedPercentPriceVal,prdctTitle,Widthvalue,DropValue,selectedVariantNameStr,Qty,matrixSelectedwidthDrop);
        }
        else
        {
          if(Widthvalue == '' && MetreValue == '')
          {
            $("#wdr #ws").text(""); 
            $("#wdr #ws").text("Please enter your Track/Pole Length");
            if(DropValue != '')
            {
              $("#wdr #ds").text("");
            }
            else
            {
              $("#wdr #ds").text(""); 
              $("#wdr #ds").text("Please enter your Drop");
            }
          }
          else if(DropValue == '' && MetreValue == '')
          {
            $("#wdr #ds").text(""); 
            $("#wdr #ds").text("Please enter your Drop");
            if(Widthvalue != '')
            {
              $("#wdr #ws").text("");
            }
            else
            {
              $("#wdr #ws").text(""); 
              $("#wdr #ws").text("Please enter your Track/Pole Length");
            }
          }
          $('html').animate({
            scrollTop: $(".breadcrumbs").offset().top
          }, 1000);
        }
    });
}); 
     
